/**
 * Universal Product Customization Fields
 * Shows/hides customization fields based on variant selection
 * Works with: Custom Text, Logo, Personalised, Custom coaster, Custom size
 */

(function() {
  'use strict';

  function init() {
    const containers = document.querySelectorAll('#product-customization-fields');
    if (!containers.length) return;
    containers.forEach(initContainer);
  }

  function initContainer(container) {
    if (container._gsaInit) return;
    container._gsaInit = true;

    const productSection = container.closest('.shopify-section, section.product, [data-section-type]') || 
                           container.closest('section') || 
                           document.body;
    const cartForm = productSection.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (cartForm) {
      if (!cartForm.getAttribute('id')) {
        cartForm.setAttribute('id', 'gsa-product-form-' + Math.random().toString(36).slice(2, 7));
      }
      const formId = cartForm.getAttribute('id');
      container.querySelectorAll('input, textarea')
        .forEach(el => el.setAttribute('form', formId));
    }

    const textField = container.querySelector('#custom-text-field');
    const logoField = container.querySelector('#custom-logo-field');
    const customSizeField = container.querySelector('#custom-size-field');
    const textInput = container.querySelector('#custom-text-input');
    const fileInput = container.querySelector('#custom-logo-input');
    const sizeInput = container.querySelector('#custom-size-input');
    const fileNameDisplay = container.querySelector('#custom-file-name');
    const charCount = container.querySelector('#custom-char-count');
    const uploadConfirmation = container.querySelector('#upload-confirmation');
    const uploadedFileName = container.querySelector('#uploaded-file-name');
    const textConfirmation = container.querySelector('#text-confirmation');
    const confirmedCustomText = container.querySelector('#confirmed-custom-text');
    const previewContainer = container.querySelector('#text-preview-container');
    const previewCanvas = container.querySelector('#text-preview-canvas');
    const logoPreviewContainer = container.querySelector('#logo-preview-container');
    const logoPreviewCanvas = container.querySelector('#logo-preview-canvas');
    const logoSizeSlider = container.querySelector('#logo-size-slider');
    const logoPreviewHint = container.querySelector('#logo-preview-hint');

    // ---- VARIANT CHANGE LISTENERS ----
    productSection.addEventListener('change', function(e) {
      if (e.target.matches('select, input[type="radio"]')) {
        setTimeout(updateFieldsVisibility, 100);
        if (textInput && textInput.value.length > 0 && previewContainer) {
          const val = textInput.value;
          loadMockup(() => drawTextPreview(val));
        }
      }
    });
    document.addEventListener('variant:change', updateFieldsVisibility);
    document.addEventListener('variantChange', updateFieldsVisibility);

    // ---- TEXT MOCKUP LOADING ----
    const mockupImg = new Image();
    mockupImg.crossOrigin = 'anonymous';

    function getTextMockupUrl() {
      const selects = productSection.querySelectorAll('variant-picker select, .product-form select, fieldset select');
      for (const select of selects) {
        const val = select.options[select.selectedIndex]?.text?.toLowerCase() || '';
        if (val.includes('5x5') || val.includes('large') || val.includes('55')) {
          return 'https://golfsimaccessories.co.uk/cdn/shop/files/5x5CustomText.png';
        }
      }
      return 'https://golfsimaccessories.co.uk/cdn/shop/files/Pyramid-Tray-Blank-4x4_Custom_Text.png';
    }

    function loadMockup(callback) {
      const url = getTextMockupUrl();
      if (mockupImg.src !== url || !mockupImg.complete) {
        mockupImg.onload = callback;
        mockupImg.src = url;
      } else {
        callback();
      }
    }

    function drawTextPreview(text) {
      if (!previewCanvas) return;
      const ctx = previewCanvas.getContext('2d');
      const W = mockupImg.naturalWidth || 1200;
      const H = mockupImg.naturalHeight || 1200;
      previewCanvas.width = W;
      previewCanvas.height = H;
      ctx.drawImage(mockupImg, 0, 0, W, H);
      if (!text) return;
      const fontSize = Math.round(W * 0.055);
      ctx.font = `bold ${fontSize}px Arial, sans-serif`;
      ctx.fillStyle = '#FFFFFF';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const is5x5 = mockupImg.src.includes('5x5');
      const x = W * 0.5;
      const y = is5x5 ? H * 0.945 : H * 0.895;
      ctx.fillText(text, x, y);
    }

    // ---- LOGO MOCKUP LOADING ----
    const logoMockupImg = new Image();
    logoMockupImg.crossOrigin = 'anonymous';
    let uploadedLogoImg = null;

    function getLogoMockupUrl() {
      const selects = productSection.querySelectorAll('variant-picker select, .product-form select, fieldset select');
      let isLarge = false;
      let isBase = false;
      let isBorder = false;
      let isBallMarker = false;

      for (const select of selects) {
        const val = select.options[select.selectedIndex]?.text?.toLowerCase() || '';
        if (val.includes('5x5') || val.includes('large') || val.includes('55')) isLarge = true;
        if (val.includes('on base') || val.includes('base')) isBase = true;
        if (val.includes('on border') || val.includes('border') || val.includes('side')) isBorder = true;
        if (val.includes('marker')) isBallMarker = true;
      }

      if (isBallMarker) {
        return 'https://golfsimaccessories.co.uk/cdn/shop/files/34_Ball_Marker_Vertical.png';
      }
      if (isBase) {
        return isLarge
          ? 'https://golfsimaccessories.co.uk/cdn/shop/files/5x5LogoBase.png'
          : 'https://golfsimaccessories.co.uk/cdn/shop/files/4x4_Logo_on_base.png';
      }
      if (isBorder) {
        return isLarge
          ? 'https://golfsimaccessories.co.uk/cdn/shop/files/5x5LogoSide.png'
          : 'https://golfsimaccessories.co.uk/cdn/shop/files/4x4_Logo_on_border.png';
      }
      return isLarge
        ? 'https://golfsimaccessories.co.uk/cdn/shop/files/5x5LogoSide.png'
        : 'https://golfsimaccessories.co.uk/cdn/shop/files/4x4_Logo_on_border.png';
    }

    function isBaseVariant() {
      const selects = productSection.querySelectorAll('variant-picker select, .product-form select, fieldset select');
      for (const select of selects) {
        const val = select.options[select.selectedIndex]?.text?.toLowerCase() || '';
        if (val.includes('on base') || val.includes('base')) return true;
      }
      return false;
    }

    function isCoasterVariant() {
      const selects = productSection.querySelectorAll('variant-picker select, .product-form select, fieldset select');
      for (const select of selects) {
        const val = select.options[select.selectedIndex]?.text?.toLowerCase() || '';
        if (val.includes('coaster')) return true;
      }
      return false;
    }

    function isBallMarkerVariant() {
      const selects = productSection.querySelectorAll('variant-picker select, .product-form select, fieldset select');
      for (const select of selects) {
        const val = select.options[select.selectedIndex]?.text?.toLowerCase() || '';
        if (val.includes('marker')) return true;
      }
      return false;
    }

    function loadLogoMockup(callback) {
      const url = getLogoMockupUrl();
      if (logoMockupImg.src !== url || !logoMockupImg.complete) {
        logoMockupImg.onload = callback;
        logoMockupImg.src = url;
      } else {
        callback();
      }
    }

    function drawCoaster(withLogo) {
      if (!logoPreviewCanvas) return;
      const ctx = logoPreviewCanvas.getContext('2d');
      const W = 800;
      const H = 800;
      logoPreviewCanvas.width = W;
      logoPreviewCanvas.height = H;

      ctx.fillStyle = '#e8e8e8';
      ctx.fillRect(0, 0, W, H);

      const cx = W * 0.5;
      const cy = H * 0.5;
      const radius = W * 0.42;
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fillStyle = '#ffffff';
      ctx.fill();
      ctx.strokeStyle = '#cccccc';
      ctx.lineWidth = 3;
      ctx.stroke();

      if (!withLogo || !uploadedLogoImg) return;

      const sliderVal = logoSizeSlider ? parseInt(logoSizeSlider.value) : 50;
      const maxLogoSize = radius * 2 * 0.8;
      const logoW = (sliderVal / 100) * maxLogoSize;
      const logoH = (uploadedLogoImg.naturalHeight / uploadedLogoImg.naturalWidth) * logoW;

      ctx.save();
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.clip();
      ctx.drawImage(uploadedLogoImg, cx - logoW / 2, cy - logoH / 2, logoW, logoH);
      ctx.restore();
    }

    function drawLogoPreview() {
      if (isCoasterVariant()) {
        drawCoaster(!!uploadedLogoImg);
        return;
      }
      if (!logoPreviewCanvas || !logoMockupImg.naturalWidth) return;
      if (!uploadedLogoImg) {
        const ctx = logoPreviewCanvas.getContext('2d');
        const W = logoMockupImg.naturalWidth;
        const H = logoMockupImg.naturalHeight;
        logoPreviewCanvas.width = W;
        logoPreviewCanvas.height = H;
        ctx.drawImage(logoMockupImg, 0, 0, W, H);
        return;
      }
      const ctx = logoPreviewCanvas.getContext('2d');
      const W = logoMockupImg.naturalWidth || 1200;
      const H = logoMockupImg.naturalHeight || 1200;
      logoPreviewCanvas.width = W;
      logoPreviewCanvas.height = H;
      ctx.drawImage(logoMockupImg, 0, 0, W, H);

      const sliderVal = logoSizeSlider ? parseInt(logoSizeSlider.value) : 50;

      if (isBallMarkerVariant()) {
        // Ball marker — centred in the middle of the black square face
        const cx = W * 0.50;
        const cy = H * 0.48;
        const maxW = W * 0.55;
        const logoW = (sliderVal / 100) * maxW;
        const logoH = (uploadedLogoImg.naturalHeight / uploadedLogoImg.naturalWidth) * logoW;
        ctx.drawImage(uploadedLogoImg, cx - logoW / 2, cy - logoH / 2, logoW, logoH);
      } else if (isBaseVariant()) {
        const cx = W * 0.50;
        const cy = H * 0.50;
        const maxRadius = W * 0.38;
        const logoSize = (sliderVal / 100) * (maxRadius * 2 * 0.9);
        const logoW = logoSize;
        const logoH = (uploadedLogoImg.naturalHeight / uploadedLogoImg.naturalWidth) * logoW;
        const drawX = cx - logoW / 2;
        const drawY = cy - logoH / 2;
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, maxRadius, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(uploadedLogoImg, drawX, drawY, logoW, logoH);
        ctx.restore();
      } else {
        const cx = W * 0.50;
        const is5x5Logo = logoMockupImg.src.includes('5x5');
        const cy = is5x5Logo ? H * 0.77 : H * 0.80;
        const maxW = W * 0.6;
        const logoW = (sliderVal / 100) * maxW;
        const logoH = (uploadedLogoImg.naturalHeight / uploadedLogoImg.naturalWidth) * logoW;
        ctx.drawImage(uploadedLogoImg, cx - logoW / 2, cy - logoH / 2, logoW, logoH);
      }
    }

    // ---- TEXT INPUT HANDLING ----
    if (textInput && charCount) {
      textInput.addEventListener('input', function() {
        const current = this.value.length;
        const max = this.maxLength || 15;
        charCount.textContent = current + '/' + max + ' characters';
        charCount.style.color = current >= max ? '#dc3545' : '';

        if (textConfirmation && confirmedCustomText) {
          if (current > 0) {
            confirmedCustomText.textContent = '"' + this.value + '"';
            textConfirmation.style.display = 'block';
          } else {
            textConfirmation.style.display = 'none';
          }
        }

        if (previewContainer) {
          if (current > 0) {
            previewContainer.style.display = 'block';
            const val = this.value;
            loadMockup(() => drawTextPreview(val));
          } else {
            previewContainer.style.display = 'none';
          }
        }
      });
    }

    // ---- LOGO SLIDER ----
    if (logoSizeSlider) {
      logoSizeSlider.addEventListener('input', function() {
        drawLogoPreview();
      });
    }

    // ---- FILE INPUT HANDLING ----
    if (fileInput) {
      fileInput.addEventListener('change', function() {
        if (this.files && this.files[0]) {
          const file = this.files[0];

          if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
            alert('Please upload a JPG or PNG file only.');
            this.value = '';
            if (fileNameDisplay) fileNameDisplay.textContent = 'No file chosen';
            if (uploadConfirmation) uploadConfirmation.style.display = 'none';
            return;
          }

          if (file.size > 10 * 1024 * 1024) {
            alert('File size must be less than 10MB.');
            this.value = '';
            if (fileNameDisplay) fileNameDisplay.textContent = 'No file chosen';
            if (uploadConfirmation) uploadConfirmation.style.display = 'none';
            return;
          }

          if (fileNameDisplay) fileNameDisplay.style.display = 'none';
          if (uploadConfirmation) {
            uploadConfirmation.style.display = 'block';
            if (uploadedFileName) uploadedFileName.textContent = file.name;
          }

          const reader = new FileReader();
          reader.onload = function(e) {
            uploadedLogoImg = new Image();
            uploadedLogoImg.onload = function() {
              loadLogoMockup(() => {
                if (logoPreviewContainer) logoPreviewContainer.style.display = 'block';
                if (logoSizeSlider) logoSizeSlider.parentElement.style.display = 'block';
                if (logoPreviewHint) {
                  logoPreviewHint.textContent = isCoasterVariant()
                    ? 'Logo is centred on the coaster — use the slider to resize'
                    : isBallMarkerVariant()
                    ? 'Logo is centred on the ball marker — use the slider to resize'
                    : isBaseVariant()
                    ? 'Logo is centred in the print area — use the slider to resize'
                    : 'Logo is centred on the front border — use the slider to resize';
                }
                drawLogoPreview();
              });
            };
            uploadedLogoImg.src = e.target.result;
          };
          reader.readAsDataURL(file);

        } else {
          if (fileNameDisplay) {
            fileNameDisplay.style.display = 'inline';
            fileNameDisplay.textContent = 'No file chosen';
          }
          if (uploadConfirmation) uploadConfirmation.style.display = 'none';
          if (logoPreviewContainer) logoPreviewContainer.style.display = 'none';
          uploadedLogoImg = null;
        }
      });
    }

    // ---- ADD TO CART LOADING STATE ----
    const addToCartBtn = productSection.querySelector('[type="submit"]');
    if (addToCartBtn && fileInput && cartForm) {
      const originalText = addToCartBtn.innerHTML;
      cartForm.addEventListener('submit', function() {
        if (fileInput.files && fileInput.files[0]) {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = `
            <span style="display:inline-flex; align-items:center; gap:8px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: gsa-spin 1s linear infinite;">
                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
              </svg>
              Uploading your image...
            </span>`;
          setTimeout(() => {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = originalText;
          }, 10000);
        }
      });
    }

    // ---- SHOW/HIDE LOGIC ----
    updateFieldsVisibility();
    setTimeout(updateFieldsVisibility, 300);
    setTimeout(updateFieldsVisibility, 800);
    setTimeout(updateFieldsVisibility, 1500);

    function updateFieldsVisibility() {
      const selectedVariant = getSelectedVariantText();
      const lowerVariant = selectedVariant.toLowerCase();

      const needsCustomText = lowerVariant.includes('custom text');
      const needsLogo = lowerVariant.includes('logo');
      const needsPersonalised = lowerVariant.includes('personalis') ||
                                lowerVariant.includes('custom coaster') ||
                                lowerVariant.includes('customised');
      const needsCustomSize = lowerVariant.includes('custom size');

      if (needsCustomText || needsLogo || needsPersonalised || needsCustomSize) {
        container.style.display = 'block';
      } else {
        container.style.display = 'none';
      }

      if (textField) {
        textField.style.display = needsCustomText ? 'block' : 'none';
        if (textInput) textInput.required = needsCustomText;
        if (needsCustomText && previewContainer) {
          previewContainer.style.display = 'block';
          loadMockup(() => drawTextPreview(textInput ? textInput.value : ''));
        } else if (!needsCustomText && previewContainer) {
          previewContainer.style.display = 'none';
        }
      }

      if (logoField) {
        logoField.style.display = (needsLogo || needsPersonalised) ? 'block' : 'none';
        if (!needsLogo && !needsPersonalised && logoPreviewContainer) {
          logoPreviewContainer.style.display = 'none';
        }
        if (needsLogo || needsPersonalised) {
          if (logoPreviewContainer) logoPreviewContainer.style.display = 'block';
          if (logoSizeSlider) logoSizeSlider.parentElement.style.display = uploadedLogoImg ? 'block' : 'none';

          if (isCoasterVariant()) {
            if (logoPreviewHint) logoPreviewHint.textContent = uploadedLogoImg
              ? 'Logo is centred on the coaster — use the slider to resize'
              : 'Upload your logo above to see it on the coaster';
            drawCoaster(!!uploadedLogoImg);
          } else {
            if (logoPreviewHint) logoPreviewHint.textContent = uploadedLogoImg
              ? (isBallMarkerVariant()
                ? 'Logo is centred on the ball marker — use the slider to resize'
                : isBaseVariant()
                ? 'Logo is centred in the print area — use the slider to resize'
                : 'Logo is centred on the front border — use the slider to resize')
              : 'Upload your logo above to see it placed on the product';
            logoMockupImg.onload = () => drawLogoPreview();
            logoMockupImg.src = getLogoMockupUrl();
            if (logoMockupImg.complete) drawLogoPreview();
          }
        }
      }

      if (customSizeField) {
        customSizeField.style.display = needsCustomSize ? 'block' : 'none';
        if (sizeInput) sizeInput.required = needsCustomSize;
      }
    }

    function getSelectedVariantText() {
      const selects = productSection.querySelectorAll('variant-picker select, [data-option-selector] select, .product-form select, fieldset select');
      let variantText = '';
      for (const select of selects) {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption) variantText += ' ' + selectedOption.text;
      }
      const radios = productSection.querySelectorAll('variant-picker input[type="radio"]:checked, .product-form input[type="radio"]:checked');
      for (const radio of radios) {
        const label = radio.closest('label')?.textContent ||
                      document.querySelector(`label[for="${radio.id}"]`)?.textContent ||
                      radio.value;
        variantText += ' ' + label;
      }
      return variantText.trim();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function() {
    setTimeout(init, 500);
  });

})();